module.exports = __webpack_public_path__ + "static/media/icon-karma.ae2dc13d.svg";